import { useCallback, useEffect, useMemo, useState } from 'react';
import { debounce } from 'throttle-debounce';

export function useDebouncedInput(
  actualValue?: string,
  onValueChange?: (newValue: string) => void,
): [string | undefined, (newValue: string) => void] {
  const [localValue, setLocalValue] = useState<string | undefined>(actualValue);

  const debouncedChange = useMemo(
    () => onValueChange && debounce(300, onValueChange),
    [onValueChange],
  );

  const onChange = useCallback(
    (newValue: string) => {
      setLocalValue(newValue);
      debouncedChange?.(newValue);
    },
    [setLocalValue, debouncedChange],
  );

  useEffect(() => {
    setLocalValue(actualValue);
  }, [actualValue]);

  return [localValue, onChange];
}
